import AncillariesLayout from './AncillariesLayout';

export default AncillariesLayout;
